import { render, staticRenderFns } from "./PerformanceSearch.vue?vue&type=template&id=564bc56f&scoped=true&lang=pug&"
import script from "./PerformanceSearch.vue?vue&type=script&lang=js&"
export * from "./PerformanceSearch.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceSearch.vue?vue&type=style&index=0&id=564bc56f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bc56f",
  null
  
)

export default component.exports